<template>
    <div>
        <div class="modal_content p-20">
            <div class="alert alert_default">
                <ul>
                    <li>{{ $t('_incoming.alert1') }}</li>
                    <li>{{ $t('_incoming.alert2') }}</li>
                    <li>{{ $t('_incoming.alert3') }}</li>
                    <li>{{ $t('_incoming.alert4') }}</li>
                </ul>
                <p>
                    <strong>{{ $t('attention') }}:</strong> {{ $t('_incoming.alert5') }}
                </p>
            </div>
        </div>
        <div v-pml-block="isLoading">
            <div class="modal_content p-20">
                <div class="row m_bottom_15" v-for="(item, index) in headers">
                    <label class="control-label col-sm-4">{{ item.toString() | pmlWordBeautify }}:</label>
                    <div class="col-sm-5">
                        <pml-select v-model="record.headers[item]" :options="options"></pml-select>
                    </div>
                </div>
            </div>
            <div class="modal_content p-20 p-t-0">
                <h5 class="m-t-0"><i class="fa fa-random"></i> {{ $t('bind_deals_to') }}:</h5>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('consultant') }}:</label>
                    <div class="col-sm-5">
                        <pml-select-members v-model="record.member_id" :only-active="true" :remove-from-options="record.follower_id"></pml-select-members>
                        <span class="error" v-if="errors['member_id']">{{ errors['member_id'] }}</span>
                    </div>
                </div>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('follower') }}:</label>
                    <div class="col-sm-5">
                        <pml-select-members v-model="record.follower_id" :only-active="true" :only-follow="true" :remove-from-options="record.member_id"></pml-select-members>
                        <span class="error" v-if="errors['follower_id']">{{ errors['follower_id'] }}</span>
                    </div>
                </div>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('pipeline') }}:</label>
                    <div class="col-sm-5">
                        <pml-select-group v-model="record.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                        <span class="error" v-if="errors['pipeline_step_id']">{{ errors['pipeline_step_id'] }}</span>
                    </div>
                </div>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('source') }}:</label>
                    <div class="col-sm-5">
                        <pml-select v-model="record.source_id" :options="sources()"></pml-select>
                        <span class="error" v-if="errors['source_id']">{{ errors['source_id'] }}</span>
                    </div>
                </div>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('segment') }}:</label>
                    <div class="col-sm-5">
                        <pml-select v-model="record.segment_id" :options="segments()"></pml-select>
                        <span class="error" v-if="errors['segment_id']">{{ errors['segment_id'] }}</span>
                    </div>
                </div>
                <div class="row m_bottom_15">
                    <label class="control-label col-sm-4">{{ $t('country') }}</label>
                    <div class="col-sm-5" :class="{'has-error': errors['country_id']}">
                        <pml-select-countries v-model="record.country_id"></pml-select-countries>
                        <span class="error" v-if="errors['country_id']">{{ errors['country_id'] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-20 p-t-0 clearfix">
            <span class="btn btn-white pull-left" @click="goBack()">{{ $t('cancel') }}</span>
            <button class="btn btn-default pull-right" @click.prevent="askToImport()" v-pml-block="isImporting">{{ $t('import') }}</button>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import bus from 'utils/events/bus'
    import { trans } from 'utils/helpers/translation'
    import { askToImport } from 'utils/helpers/sweet-alert'
    import { importFile } from 'services/incoming'
    import { mapGetters } from 'vuex'
    import { map, orderBy } from 'lodash'
    import { checkKeywords } from 'utils/helpers/keyword'

    export default {
        name: 'IncomingCrossData',
        data () {
            return {
                isImporting: false,
                isLoading: false,
                record: {
                    headers: {},
                    filename: null
                },
                errors: [],
                headers: [],
                dealFields: []
            }
        },
        created () {
            bus.$on('crossDataIncoming', this.crossData)
        },
        destroyed () {
            bus.$off('crossDataIncoming')
        },
        mounted () {
            this.isLoading = true
        },
        computed: {
            ...mapGetters({
                'sources': 'getActiveSources',
                'segments': 'getActiveSegments',
                'members': 'getActiveMembers',
                'member': 'getMember',
                'pipelines': 'getPipelines'
            }),
            options () {
                let list = map(this.dealFields, (obj) => {
                    return { id: obj.id, name: trans(obj.name) }
                })

                return orderBy(list, ['name'])
            }
        },
        methods: {
            crossData (data) {
                this.record.filename = data.filename
                this.headers = data.headers
                this.dealFields = data.dealFields
                this.isLoading = false
                this.checkKeyword()
            },
            askToImport () {
                askToImport()
                    .then((response) => (response.value) ? this.import() : null)
            },
            import () {
                this.isImporting = true
                Notify.info(trans('_notifications.import.wait'))
                importFile(this.record)
                    .then(() => {
                        Notify.success(trans('_notifications.import.success'), {icon: 'wi wi-cloud-up', duration: -1})
                        bus.$emit('doFilterIncoming')
                        this.goBack()
                    })
                    .catch(error => Notify.error(trans(error.response.data.slug), {duration: -1}))
                    .then(() => { this.isImporting = false })
            },
            checkKeyword () {
                for (let i in this.headers) {
                    let word = checkKeywords(this.headers[i])
                    if (word)
                        this.record.headers[this.headers[i]] = word
                }
            },
            goBack () {
                bus.$emit('goBack')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/import/CrossData.vue